import { defineStore } from "pinia";
import { useUserNotifications } from "~/composables/useUserNotifications";
import { computed } from "vue";

export const useNotificationsStore = defineStore("notifications", () => {
	const {
		notifications,
		error,
		loading,
		getNotifications,
		markAsRead,
		readAll,
		deleteNotification,
		totalNotifications,
		page,
		notificationCount,
	} = useUserNotifications();

	const fetchNotifications = async (page: number = 1) => {
		await getNotifications(page);
	};

	const addNotification = (notification: any) => {
		const notificationKey = notification.notification_id || notification.id;
		const alreadyExists = notifications.value.some((item: any) => {
			const itemKey = item.notification_id || item.id;
			return itemKey && notificationKey && itemKey === notificationKey;
		});
		if (alreadyExists) return;

		notifications.value.unshift(notification);
		notificationCount.value++;
	};

	const currentPage = computed(() => page.value);

	return {
		notifications,
		error,
		loading,
		notificationCount,
		fetchNotifications,
		markNotificationAsRead: markAsRead,
		markAllAsRead: readAll,
		removeNotification: deleteNotification,
		totalNotifications,
		currentPage,
		addNotification,
	};
});
